Namespace 'Models.Parsers'

class Models.Parsers.InstagramMessageParser
  constructor: ->
    @parsers = [
      new Models.Parsers.InstagramMessageTextParser,
      new Models.Parsers.InstagramMessageMediaParser,
      new Models.Parsers.InstagramMessageStoryMentionParser,
      new Models.Parsers.InstagramMessageStoryReplyParser
    ]
    @defaultParser = new Models.Parsers.InstagramMessageUnsupportedParser

  parse: (messageJSON) ->
    parser = @_findParser(messageJSON)
    parser.parse(messageJSON)

  _findParser: (messageJSON) ->
    parser = @parsers.find((parser) -> parser.canHandle(messageJSON))
    return @defaultParser unless parser
    parser
